import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import {
  RETURN_TO_COMPANY_ADDRESS_ID,
  RETURN_TO_COMPANY_ID,
  RETURN_TO_FOB,
  RETURN_TO_SHIPPING_ADDRESS,
  RETURN_TO_SHIPPING_ADDRESS_ID,
  RETURN_TO_SHIPPING_METHOD,
  RETURN_TO_TYPE
} from "APP_ROOT/constants";
import pojo from "LIB/pojos";
import { SHIP_DATE } from "MODULES/Lots/constants";
import Form from "./Form";

export default function EditShipping({ open, close, managedRepairOrder }) {
  const initialValues = pojo(managedRepairOrder).pick(
    RETURN_TO_FOB,
    RETURN_TO_SHIPPING_METHOD,
    RETURN_TO_TYPE,
    RETURN_TO_COMPANY_ID,
    RETURN_TO_COMPANY_ADDRESS_ID,
    RETURN_TO_SHIPPING_ADDRESS,
    RETURN_TO_SHIPPING_ADDRESS_ID,
    SHIP_DATE
  );

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Managed Repair Order Shipping Info</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        managedRepairOrder={managedRepairOrder}
        enableReinitialize
      />
    </Modal>
  );
}

EditShipping.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  managedRepairOrder: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Detail/ReturnToShippingDetails/EditShipping.jsx